import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { AdminPage } from '@/pages/AdminPage';
import { CoordinadorPage } from '@/pages/CoordinadorPage';
import { FlotaPage } from '@/pages/FlotaPage';
import { UsuariosPage } from '@/pages/UsuariosPage';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#0A0A0A] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#495057] font-['IBM_Plex_Sans']">Cargando...</p>
        </div>
      </div>
    );
  }

  const getHomePath = (u) => {
    if (u.role === 'admin') return '/admin';
    if (u.role === 'coordinador') return '/coordinador';
    return '/dashboard';
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          user ? (
            <Navigate to={getHomePath(user)} replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route path="/login" element={user ? <Navigate to={getHomePath(user)} replace /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to="/dashboard" replace /> : <RegisterPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly={true}>
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/coordinador"
        element={
          <ProtectedRoute coordinadorOnly={true}>
            <CoordinadorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/flota"
        element={
          <ProtectedRoute adminOnly={true}>
            <FlotaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/usuarios"
        element={
          <ProtectedRoute adminOnly={true}>
            <UsuariosPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;